import { LoadStatus } from '@/components/LoadPlaceholder';
import { IHomeDataState } from './type';

export const POT_MENU_BAR = [
  {
    value: '/web',
    title: '首页',
  },
  {
    value: '/web/course-center',
    title: '课程中心',
  },
];

/**
 * 模块 Code
 */
export const enum EnumModuleCode {
  // 行业icon运营位
  Icon = 'module_biz_icon',
  // 热门直播运营位
  Live = 'module_popular_live',
  // 热门课程运营位
  PopularCourse = 'module_popular_course',
  // 课程运营位
  Course = 'module_course',

  Banner = 'module_banner_classify',
}

export const enum LiveStreamingStatus {
  // 行业icon运营位
  LiveProgress = '进入直播',
  // 热门直播运营位
  LiveReservation = '预约直播',
  // 热门课程运营位
  LivePlayback = '查看回放',
  // 课程运营位
  LiveCancel = '取消预约',
  End = '已结束',
}

/**
 * 频道模块类型
 */
export const enum EnumChannelType {
  // 1：模块化频道
  Module = 1,
  // 2：iframe频道
  Iframe = 2,
}

export const initIcon = {
  id: 0,
  name: '',
  iconUrl: '',
  dataRule: '',
};

export const initCourseTab = {
  id: 0,
  moduleCode: EnumModuleCode.Course,
  moduleDisplayTitle: '全部',
  moduleContent: '',
};

export const initChannel = {
  id: 0,
  tabType: EnumChannelType.Module,
  tabName: '推荐',
};

export const initialState: IHomeDataState = {
  pageLoadStatus: LoadStatus.INITIAL,
  homeDataLoadStatus: LoadStatus.INITIAL,
  originData: [],
  cpnData: {
    channelList: [],
    curChannel: initChannel,
    curIcon: initIcon,
    curCourseTab: initCourseTab,
    curModuleContentData: [],
    defaultBannerId: 0,
  },
};

export const LIST_SEARCH_PARAM_KEY = 'keyword'; // 路由获取关键词
export const LIST_PAGE_PARAM_KEY = 'pageNo'; // 当前页数
export const LIST_PAGE_SIZE_PARAM_KEY = 'pageSize'; // 条数
export const LIST_PAGE_SIZE = 20; // 默认搜索条数
